var path = 'areas/environments/machines/machine_events.html';
var html = "<script octo-section=breadcrumbs type=text/ng-template> <li ng-show=\"machine\"><a href=\"#/machines/{{ machine.Id }}/deployments\">Events</a></li> </script> <script octo-section=machine_tools type=text/ng-template> <spin active=\"isLoading.busy\"></spin> </script> <div class=container-fluid> <h3>Event History</h3> <loading-wrapper busy=isLoading once=true> <event-table events=events.Items></event-table> <octo-paginator collection=vm.events is-loading=vm.isLoading page-selected=vm.selectPage></octo-paginator> </loading-wrapper> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/machines/machine_events.html
// module id = 2038382705121309
// module chunks = 1